import { Component, Input, OnInit } from '@angular/core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { CommonFunction } from 'src/app/helpers/commonFunction';
import { NcdclientService } from 'src/app/services/NCD/ncdclient.service';
import { environment } from 'src/environments/environment';
import * as JSZip from 'jszip';
import { saveAs } from 'file-saver';
import categoryData from './categoryJSON';
import { AlertComponent } from '../../alert/alert.component';
@Component({
  selector: 'app-upload-tab',
  templateUrl: './upload-tab.component.html',
  styleUrls: ['./upload-tab.component.css']
})
export class UploadTabComponent implements OnInit {

  categoryData: any = categoryData;
  @Input() issueId: any;
  uploadedFiles: any = [];
  loader = false;
  uloadLoader = false;
  //public fileExtension: boolean = true;
  fileExtension: any;
  documents: any;
  editDocument: any;
  userAllow = [];
  isAccessRightsGiven: boolean;
  public fileExtensions: boolean = true;

  constructor(private ncdService: NcdclientService, private alert: AlertComponent,
     public commonFunction: CommonFunction, private modalService: NgbModal) {
    // this.getNCDUserFields();
    
  }

  ngOnInit() {
    this.getAllUploadedFiles();
    this.getDocuments();
  }
  allExtensions()
  {
      return ["csv", "xlsx", "xls", "jpg", "jpeg", "png", "doc", "docx", "txt", "pdf", "ppt","pptx", "mp4","apk","bat","bin","cgi","com","exe","jar","py","wsf","aif","cda","iff","mid","midi","mp3","mpa","wav","wma","wpl","avi","flv","h264","m4v","mkv","mov","mpg","mpeg","rm","swf","vob","wmv","3g2","3gp","odt","msg","rtf","tex","wks","wps","wpd","ods","xlr","key","odp","pps","accdb","dat","db","dbf","log",
      "mdb","pdb","sav","sql","tar","bak","cab","cfg","cpl","cur","dll","dmp","drv","icns","ico","ini","lnk","msi","sys","tmp","asp","aspx","cer","cfm","cgi","pl","css","htm","html","js","jsp","part","php","rss","xhtml","ai","bmp","gif","ico","max","obj","ps","psd","svg","tif","tiff","3ds","3dm"];
              
  }
  
  isInArray(array, word) {
      return array.indexOf(word.toLowerCase()) > -1;
  }

  uploadFile(event, category, documentId) {

    // category.file = event.target.files[0];
    // this.ncdService.UploadNCDDoc(this.getObject(category), documentId).then(resData => {
    //   this.getAllUploadedFiles();
    // }).catch(error => {
    // })

    // var checkfile = this.commonFunction.checkFileExtension(event);
    var count = 0;
    var self = this;
    // console.log('file changed', event.target.files[0])
    var allowedExtensions = ["csv", "xlsx", "xls", "doc", "docx", "txt", "pdf", "ppt", "zip"];
    var filename = event.target.files[0].name;
    var checkFilesExtension = filename.toString().split('.').pop();
    // console.log(" checkFilesExtension : ====>  ", checkFilesExtension)
    this.fileExtension = filename.split('.');
    // console.log(" this.fileExtension ", this.fileExtension)
    this.fileExtension.forEach(function (value, key) {
      // console.log(key + ': ' + value);
      if (self.isInArray(self.allExtensions(), value)) {
          count++;
      }
  });

   // this.fileExtension = filename.toString().split('.').pop();
     if(count == 1 && self.isInArray(allowedExtensions, checkFilesExtension)){
      category.file = event.target.files[0];
      this.fileExtensions = true;
    this.ncdService.UploadNCDDoc(this.getObject(category), documentId).then(resData => {
      if(resData.status == 0){
        this.getAllUploadedFiles();
      }else{
        if(resData.message){
          this.alert.error(resData.message);
        }else{
          this.alert.error("Opps! something went wrong");
        }
       
      }
    }).catch(error => {
    })
    }else{
      this.alert.error('Please upload valid file only.')
     }
  }

//   isInArray(array, word) {
//     return array.indexOf(word.toLowerCase()) > -1;
// }

  getAllUploadedFiles() {
    this.ncdService.getUploadedDoc(this.issueId).subscribe(resData => {
      this.uploadedFiles = resData;
    }, error => {
    });
  }

  getObject(data) {
    const dataValue = {
      file: data.file,
      SrNo: data.srNo,
      DocumentName: data.documentName,
      IssueId: this.issueId,
      OriginalFileName: data.file.name,
      FileType: data.file.type,
      FileSize: data.file.size,
      ModifiedDate: data.file.name,
    }
    return dataValue;
  }

  getFileUploded(srNo) {
    const filePath = this.uploadedFiles.filter(ele => ele.SrNo === srNo);
    return filePath.length > 0 ? filePath[0] ? filePath[0].DocumentManagement ? filePath[0].DocumentManagement.OriginalFileName : '' : '' : '';
  }

  getFileURL(srNo) {
    const filePath = this.uploadedFiles.filter(ele => ele.SrNo === srNo);
    return filePath.length > 0 ? filePath[0] ? filePath[0].DocumentManagement ? environment.PSSFileurl + filePath[0].DocumentManagement.FilePath : '' : '' : '';
  }

  getDocumentId(srNo) {
    const filePath = this.uploadedFiles.filter(ele => ele.SrNo === srNo);
    return filePath.length > 0 ? filePath[0] ? filePath[0].DocumentManagement ? filePath[0].DocumentManagement._id : '' : '' : '';
  }

  uploadMultipeFiles(event) {
    this.uloadLoader = true;
    const files = event.target.files;
    const payloadForMultipleUpload = [];
    const payloadForMultipleUpdates = [];


    var validfile = this.commonFunction.checkFileExtensionForNCD(event);
     if(validfile){
        this.ncdService.uploadMultipleDoc(files).then(resData => {
          if (resData) {
            resData.forEach(element => {
              const OriginalFileName = element.split('-')[1];
              const fileName = element.split('-')[1].split('.');
              const jsonObject = this.categoryData.filter(ele => ele.SrNo === fileName[0].toString());
              if (jsonObject.length > 0) {
                jsonObject[0].filePath = element;
                jsonObject[0].OriginalFileName = OriginalFileName;
                jsonObject[0].FileType = fileName[1];
                const existingFile = this.uploadedFiles.filter(ele => ele.SrNo === jsonObject[0].SrNo);
                if (existingFile.length > 0) {
                  jsonObject[0].id = this.getDocumentId(jsonObject[0].SrNo);
                  payloadForMultipleUpdates.push(this.getMultipleDocsObject(jsonObject[0]));
                } else {
                  payloadForMultipleUpload.push(this.getMultipleDocsObject(jsonObject[0]));
                }
              }else{
                this.uloadLoader = false;
                this.alert.error('Please select valid files named with serial number.')
              }
            });
            if (payloadForMultipleUpdates.length > 0) {
              this.updatesMultipleFile(payloadForMultipleUpdates);
            }
            if (payloadForMultipleUpload.length > 0) {
              this.uploadMultipleFile(payloadForMultipleUpload);
            }
          }
        }).catch(error => {
          this.uloadLoader = false;
        });
      }else{
        this.alert.error('Please select valid files only.')
      }
     }

  uploadMultipleFile(payload) {
    this.ncdService.uploadDocs(payload).subscribe(resData => {
      this.getAllUploadedFiles();
      this.alert.success(payload.length + 'New Files are uploaded');
      this.uloadLoader = false;
    }, error => {
      this.uloadLoader = false;
    })
  }

  updatesMultipleFile(payload) {
    this.ncdService.updateDocs(payload, this.issueId).subscribe(resData => {
      this.getAllUploadedFiles();
      this.alert.success(payload.length + ' Files are updated');
      this.uloadLoader = false;
    }, error => {
      this.uloadLoader = false;
    })
  }


  downloadAllFiles() {
    this.loader = true;
    const jszip = new JSZip();
    let dataCount = this.uploadedFiles.length;
    const promises = [];

    this.uploadedFiles.forEach((element, i) => {
      // JSZipUtils.getBinaryContent(this.getFileURL(element.SrNo), async (err, data) => {
      //   if (!err) {
      //     var dic = { base64: true, binary: true };
      //     promises.push(data)
      //     jszip.file(element.DocumentManagement.DocumentName + "." + element.DocumentManagement.FileType, data, dic);
      //   } else {
      //   }
      //   if (data) {
      //     dataCount = dataCount - 1;
      //     if (dataCount === 0) {
      //       this.downloadFile(jszip);
      //     }
      //   }
      // });
    })
  }

  downloadFile(jszip) {
    jszip.generateAsync({ type: 'blob' }).then((data) => {
      saveAs(data, 'NCDDocuments.zip');
      this.alert.success('Successfully Downloaded');
      this.loader = false;
    }).catch(error => {
      this.loader = false;
    })
  }

  getMultipleDocsObject(data) {
    const dataValue = {
      id: data.id,
      FilePath: data.filePath,
      SrNo: data.SrNo,
      DocumentName: data.TypeofDocument,
      IssueId: this.issueId,
      OriginalFileName: data.OriginalFileName,
      FileType: data.FileType,
      ModifiedDate: new Date().toUTCString(),
    }
    return dataValue;
  }

  getDocuments() {
    this.ncdService.getDocListWithAccessRightsForLoggedInUser().subscribe(resData => {
      this.documents = resData;
    }, error => {

    })
  }

  onEditDocument(srNo, id) {
    this.editDocument = this.issueId;
    this.ncdService.setDocument({ id: id, srNo: srNo, issueId: this.issueId });
  }

  // getNCDUserFields() {
  //   var loggedInUser = {
  //     userId: JSON.parse(localStorage.getItem('user'))._id,
  //   }
  //   this.ncdService.getNCDUserFieldBy(loggedInUser).subscribe(resData => {
  //     //console.log("TCL: getNCDUserFields444444 -> resData", resData)
  //     this.userAllow = resData;
  //   }, error => {
  //     // //console.log("TCL: EditFieldsByUserComponent -> getNCDUserFields -> error", error)
  //   })
  // }



//  getNCDUserFieldsWithAccessRights() {
//     let userId = JSON.parse(localStorage.getItem('user'))._id;
//     this.ncdService.getNCDUserAccessForEditFields(userId, this.documentId).subscribe(resData => {
//       //console.log('****************************************', resData)
//       // this.getIssue(resData);
//     }, error => {
//       // //console.log("TCL: EditFieldsByUserComponent -> getNCDUserFieldsWithAccessRights -> error", error)
//     })
//   }


  filterValidatiopn(id) {
    const data = this.userAllow.filter(ele => ele.NCDDocuments === id);
    return data.length > 0;
  }

  openEditComponent(docId, srNo){
    // const modalRef = this.modalService.open(EditFieldsByUserComponent, {
    //   backdrop: 'static',
    //   size: "lg"
    // })

    // modalRef.componentInstance.issueId = this.issueId;
    // modalRef.componentInstance.documentId = docId;
    // modalRef.componentInstance.srNoOfDoc = srNo;

    // modalRef.result.then(resp => {
    //   // this.getIssueSpecificTermsheetDetails();
    // }, (error) => {
    // })
  }
}
